import { useCallback } from 'react';
import { LocalVideoTrack } from 'twilio-video';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useLocalVideoToggle() {
  const {
    room: { localParticipant },
    localTracks,
  } = useVideoContext();

  const videoTrack = localTracks.find((track): track is LocalVideoTrack => track.kind === 'video');

  const toggleVideoEnabled = useCallback(() => {
    if (!videoTrack) {
      return;
    }

    videoTrack.enable(!videoTrack.isEnabled);
  }, [videoTrack]);

  return [videoTrack?.isEnabled ?? false, toggleVideoEnabled] as const;
}
